import React, { useCallback } from 'react';

import classNames from 'classnames';

import CheckSymbol from '@travauxlib/shared/src/components/DesignSystem/assets/CheckSymbolFilled.svg?react';

import { ActionListIconContainer } from './ActionListIconContainer';
import { determineBgColor } from './utils/styleHelper';

import type { OptionItemType } from './type';

type OptionItemProps = {
  closeActionList?: () => void;
  small?: boolean;
} & OptionItemType;

export const OptionItem: React.FC<OptionItemProps> = ({
  disabled,
  label,
  onChange,
  closeActionList,
  value,
  small,
  active,
  selected,
}) => {
  const refinedOnClick = useCallback(() => {
    onChange(!value);
    closeActionList?.();
  }, [onChange, closeActionList, value]);

  return (
    <button
      type="button"
      disabled={disabled}
      onClick={refinedOnClick}
      className={classNames(
        'flex items-center py-xs pr-sm pl-[0.85rem] hover:action-bg-neutral-weak-hover active:action-bg-neutral-weak-pressed w-full',
        determineBgColor(selected, active),
        {
          'action-bg-neutral-weak-disabled text-disabled hover:action-bg-neutral-weak-disabled active:action-bg-neutral-weak-disabled':
            disabled,
        },
      )}
    >
      <ActionListIconContainer
        small={small}
        className="icon-success-strong mr-xs"
        disabled={disabled}
      >
        {value && <CheckSymbol />}
      </ActionListIconContainer>
      <span
        className={classNames('whitespace-nowrap text-b2', {
          'text-b3': small,
        })}
      >
        {label}
      </span>
      <ActionListIconContainer small={small} />
    </button>
  );
};
